import { EUserRole } from '@/types/consts';

export const getUsersUrlByRoleName = (roleName?: string, id?: number) => {
  if (roleName === EUserRole.TEAMLEAD) {
    return `team-admin/users/${id || ''}`;
  }

  if (roleName === EUserRole.SUPER_ADMIN) {
    return `super-admin/users/${id || ''}`;
  }

  if (roleName === EUserRole.RW_ADMIN) {
    return `rw-admin/users/${id || ''}`;
  }

  return `users`;
};

export const getUserChallengesUrlByRoleName = (roleName?: string) => {
  if (roleName === EUserRole.TEAMLEAD) {
    return 'team-admin/users';
  }

  return 'users';
};

export const getChallengesUrlByRoleName = (roleName?: string) => {
  if (roleName === EUserRole.SUPER_ADMIN) {
    return 'super-admin/companies';
  }

  if (roleName === EUserRole.RW_ADMIN) {
    return 'rw-admin/companies';
  }

  if (roleName === EUserRole.TEAMLEAD) {
    return 'team-admin/companies';
  }

  return 'companies';
};
